import { useMutation, useQuery } from "@tanstack/react-query";
import PickupSummaryService from "../app/data/pickup/pickupSummaryService";
import { TerminalViewPickupSummaryFilterListModel, CustomerViewPickupSummaryFilterListModel } from "../app/data/pickup/models";

const pickupSummaryService = PickupSummaryService.getInstance();

export const usePickupSummary = (filter: TerminalViewPickupSummaryFilterListModel, page?: number) => {
  return useQuery({
    queryKey: ["GET_PICKUP_SUMMARY", filter, 0],
    queryFn: () => pickupSummaryService.getPickupSummaryList(filter, 0),
    select: (res) => res.data,
    staleTime: 1000 * 60 * 5,
  });
};

export const usePickupSummaryTiles = (filter: TerminalViewPickupSummaryFilterListModel, page?: number) => {
  return useQuery({
    queryKey: ["GET_PICKUP_SUMMARY_TILES", filter, 0],
    queryFn: () => pickupSummaryService.getPickupSummaryTiles(filter, 0),
    select: (res) => res.data,
    staleTime: 1000 * 60 * 5,
  });
};

export const useOriginTerminals = (search: string) => {
  return useQuery({
    queryKey: ["GET_ORIGIN_TERMINALS", search],
    queryFn: () => pickupSummaryService.fetchOriginTerminals(search),
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5,
  });
};

export const useDestinationTerminals = (search: string) => {
  return useQuery({
    queryKey: ["GET_DESTINATION_TERMINALS", search],
    queryFn: () => pickupSummaryService.fetchDestinationTerminals(search),
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5,
  });
};

export const useTerminalViewPickupSummaryDetail = (terminalViewNumber: number, filter?: TerminalViewPickupSummaryFilterListModel, page?: number) => {
  return useQuery({
    queryKey: ["GET_TERMINAL_VIEW_PICKUPSUMMARY_DETAIL", terminalViewNumber, filter, page],
    queryFn: () => pickupSummaryService.getTerminalViewPickupSummaryList(terminalViewNumber, filter, page),
    select: (res) => res.data,
    staleTime: 1000 * 60 * 5,
  });
};

//customerview hooks

export const useCustomerViewPickupSummary = (filter: CustomerViewPickupSummaryFilterListModel, page?: number) => {
  return useQuery({
    queryKey: ["GET_CUSTOMER_PICKUP_SUMMARY", filter, 0],
    queryFn: () => pickupSummaryService.getCustomerViewPickupSummaryList(filter, 0),
    select: (res) => res.data,
    staleTime: 1000 * 60 * 5,
  });
};

export const useCustomerViewPickupSummaryTiles = (filter: CustomerViewPickupSummaryFilterListModel, page?: number) => {
  return useQuery({
    queryKey: ["GET_CUSTOMER_PICKUP_SUMMARY_TILES", filter, 0],
    queryFn: () => pickupSummaryService.getCustomerViewPickupSummaryTiles(filter, 0),
    select: (res) => res.data,
    staleTime: 1000 * 60 * 5,
  });
};

export const useRequesterCompany = () => {
  return useQuery({
    queryKey: ["GET_REQUESTED_COMPANY"],
    queryFn: () => pickupSummaryService.fetchRequesterCompany(),
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5,
  });
};

export const useCustomerViewPickupSummaryDetail = (terminalViewNumber: number, filter?: CustomerViewPickupSummaryFilterListModel, page?: number) => {
  return useQuery({
    queryKey: ["GET_CUSTOMER_VIEW_PICKUPSUMMARY_DETAIL", terminalViewNumber, filter, page],
    queryFn: () => pickupSummaryService.getCustomerViewPickupDetailList(terminalViewNumber, filter, page),
    select: (res) => res.data,
    staleTime: 1000 * 60 * 5,
  });
};

export const useDownloadCSVTerminalView = () => {
  return useMutation({
    mutationFn: (filter) =>
      pickupSummaryService.getDownloadCSVTerminalView(filter),
  });
};


export const useDownloadCSVCustomerView = () => {
  return useMutation({
    mutationFn: (filter) =>
      pickupSummaryService.getDownloadCSVCustomerView(filter),
  });
};